import axios from "axios";
import {
  STATUS_OPTIONS,
  STATUS_LABELS,
  STATUS_SOFT_BADGE,
} from "@/constants";

// Shared status helpers. The option lists come from the backend
// (GET /applications/status_options/) so the UI can never offer a status the
// API does not know; STATUS_OPTIONS is only the fallback before it loads.
export default {
  data() {
    return { statusMeta: { statuses: [], allowed: {} } };
  },
  computed: {
    // every valid status, for filter bars
    statusFilterOptions() {
      return this.statusMeta.statuses.length
        ? this.statusMeta.statuses
        : STATUS_OPTIONS;
    },
  },
  created() {
    this.loadStatusMeta();
  },
  methods: {
    loadStatusMeta() {
      return axios
        .get("/applications/status_options/")
        .then((res) => {
          if (res.data && Array.isArray(res.data.statuses)) {
            this.statusMeta = res.data;
          }
        })
        .catch(() => {});
    },
    // statuses the logged-in role may move an application to from `current`
    allowedStatusOptions(current) {
      return (this.statusMeta.allowed || {})[current] || [];
    },
    statusLabel(status) {
      return STATUS_LABELS[status] || status || "";
    },
    statusBadgeClass(status) {
      return STATUS_SOFT_BADGE[status] || "badge-soft-secondary";
    },
  },
};
